"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** The default LoadingPlaceholder is full width */
var LoadingPlaceholder = function LoadingPlaceholder(_ref) {
  var tiny = _ref.tiny,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      xlarge = _ref.xlarge,
      squared = _ref.squared,
      circled = _ref.circled,
      animated = _ref.animated,
      props = _objectWithoutProperties(_ref, ["tiny", "small", "medium", "large", "xlarge", "squared", "circled", "animated"]);

  var placeholderClasses = {
    'co-placeholder': true,
    'co-placeholder--animated': animated,
    'co-placeholder--square': squared,
    'co-placeholder--circle': circled
  };
  var sizes = {
    tiny: tiny,
    small: small,
    medium: medium,
    large: large,
    xlarge: xlarge
  };
  return _react.default.createElement(_styler.default, {
    classNames: placeholderClasses,
    modifiers: _objectSpread({}, sizes)
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)));
  });
};

var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('tiny', 'small', 'medium', 'large', 'xlarge');
LoadingPlaceholder.propTypes = {
  /** {bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@ */
  tiny: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@ */
  small: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@ */
  medium: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@ */
  large: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@ */
  xlarge: exclusiveSizes,
  circled: _propTypes.bool,
  squared: _propTypes.bool,
  animated: _propTypes.bool
};
LoadingPlaceholder.defaultProps = {
  animated: true
};
var _default = LoadingPlaceholder;
exports.default = _default;
LoadingPlaceholder.__docgenInfo = {
  "description": "The default LoadingPlaceholder is full width",
  "methods": [],
  "displayName": "LoadingPlaceholder",
  "props": {
    "animated": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tiny": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@"
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@"
    },
    "medium": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@"
    },
    "xlarge": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@tiny@@ @@small@@ @@medium@@ @@large@@ @@xlarge@@"
    },
    "circled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "squared": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};